/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { DownloadDetailsRequestBuilderRequestsMetadata, type DownloadDetailsRequestBuilder } from './downloadDetails/index.js';
// @ts-ignore
import { GetRequestBuilderRequestsMetadata, type GetRequestBuilder } from './get/index.js';
// @ts-ignore
import { GetBookingStatusRequestBuilderRequestsMetadata, type GetBookingStatusRequestBuilder } from './getBookingStatus/index.js';
// @ts-ignore
import { GetBookingStatusByFileRequestBuilderRequestsMetadata, type GetBookingStatusByFileRequestBuilder } from './getBookingStatusByFile/index.js';
// @ts-ignore
import { GetByFileRequestBuilderRequestsMetadata, type GetByFileRequestBuilder } from './getByFile/index.js';
// @ts-ignore
import { GetDetailsRequestBuilderRequestsMetadata, type GetDetailsRequestBuilder } from './getDetails/index.js';
// @ts-ignore
import { GetHistoryRequestBuilderRequestsMetadata, type GetHistoryRequestBuilder } from './getHistory/index.js';
// @ts-ignore
import { GetMessagesRequestBuilderRequestsMetadata, type GetMessagesRequestBuilder } from './getMessages/index.js';
// @ts-ignore
import { GetMessagesByFileRequestBuilderRequestsMetadata, type GetMessagesByFileRequestBuilder } from './getMessagesByFile/index.js';
// @ts-ignore
import { GetVerificationsRequestBuilderRequestsMetadata, type GetVerificationsRequestBuilder } from './getVerifications/index.js';
// @ts-ignore
import { GetVerificationsByFileRequestBuilderRequestsMetadata, type GetVerificationsByFileRequestBuilder } from './getVerificationsByFile/index.js';
// @ts-ignore
import { RetryRequestBuilderRequestsMetadata, type RetryRequestBuilder } from './retry/index.js';
// @ts-ignore
import { RetryByFileRequestBuilderRequestsMetadata, type RetryByFileRequestBuilder } from './retryByFile/index.js';
// @ts-ignore
import { SendMessageRequestBuilderRequestsMetadata, type SendMessageRequestBuilder } from './sendMessage/index.js';
// @ts-ignore
import { SendMessageByFileRequestBuilderRequestsMetadata, type SendMessageByFileRequestBuilder } from './sendMessageByFile/index.js';
// @ts-ignore
import { type UpdateStatusRequestBuilder, UpdateStatusRequestBuilderRequestsMetadata } from './updateStatus/index.js';
// @ts-ignore
import { type UpdateStatusByFileRequestBuilder, UpdateStatusByFileRequestBuilderRequestsMetadata } from './updateStatusByFile/index.js';
// @ts-ignore
import { type VerifyRequestBuilder, VerifyRequestBuilderRequestsMetadata } from './verify/index.js';
// @ts-ignore
import { type VerifyByFileRequestBuilder, VerifyByFileRequestBuilderRequestsMetadata } from './verifyByFile/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard
 */
export interface DashboardRequestBuilder extends BaseRequestBuilder<DashboardRequestBuilder> {
    /**
     * The DownloadDetails property
     */
    get downloadDetails(): DownloadDetailsRequestBuilder;
    /**
     * The GetBookingStatus property
     */
    get getBookingStatus(): GetBookingStatusRequestBuilder;
    /**
     * The GetBookingStatusByFile property
     */
    get getBookingStatusByFile(): GetBookingStatusByFileRequestBuilder;
    /**
     * The GetByFile property
     */
    get getByFile(): GetByFileRequestBuilder;
    /**
     * The GetDetails property
     */
    get getDetails(): GetDetailsRequestBuilder;
    /**
     * The GetHistory property
     */
    get getHistory(): GetHistoryRequestBuilder;
    /**
     * The GetMessages property
     */
    get getMessages(): GetMessagesRequestBuilder;
    /**
     * The GetMessagesByFile property
     */
    get getMessagesByFile(): GetMessagesByFileRequestBuilder;
    /**
     * The GetPath property
     */
    get getPath(): GetRequestBuilder;
    /**
     * The GetVerifications property
     */
    get getVerifications(): GetVerificationsRequestBuilder;
    /**
     * The GetVerificationsByFile property
     */
    get getVerificationsByFile(): GetVerificationsByFileRequestBuilder;
    /**
     * The Retry property
     */
    get retry(): RetryRequestBuilder;
    /**
     * The RetryByFile property
     */
    get retryByFile(): RetryByFileRequestBuilder;
    /**
     * The SendMessage property
     */
    get sendMessage(): SendMessageRequestBuilder;
    /**
     * The SendMessageByFile property
     */
    get sendMessageByFile(): SendMessageByFileRequestBuilder;
    /**
     * The UpdateStatus property
     */
    get updateStatus(): UpdateStatusRequestBuilder;
    /**
     * The UpdateStatusByFile property
     */
    get updateStatusByFile(): UpdateStatusByFileRequestBuilder;
    /**
     * The Verify property
     */
    get verify(): VerifyRequestBuilder;
    /**
     * The VerifyByFile property
     */
    get verifyByFile(): VerifyByFileRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const DashboardRequestBuilderUriTemplate = "{+baseurl}/Dashboard";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DashboardRequestBuilderNavigationMetadata: Record<Exclude<keyof DashboardRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    downloadDetails: {
        requestsMetadata: DownloadDetailsRequestBuilderRequestsMetadata,
    },
    getBookingStatus: {
        requestsMetadata: GetBookingStatusRequestBuilderRequestsMetadata,
    },
    getBookingStatusByFile: {
        requestsMetadata: GetBookingStatusByFileRequestBuilderRequestsMetadata,
    },
    getByFile: {
        requestsMetadata: GetByFileRequestBuilderRequestsMetadata,
    },
    getDetails: {
        requestsMetadata: GetDetailsRequestBuilderRequestsMetadata,
    },
    getHistory: {
        requestsMetadata: GetHistoryRequestBuilderRequestsMetadata,
    },
    getMessages: {
        requestsMetadata: GetMessagesRequestBuilderRequestsMetadata,
    },
    getMessagesByFile: {
        requestsMetadata: GetMessagesByFileRequestBuilderRequestsMetadata,
    },
    getPath: {
        requestsMetadata: GetRequestBuilderRequestsMetadata,
    },
    getVerifications: {
        requestsMetadata: GetVerificationsRequestBuilderRequestsMetadata,
    },
    getVerificationsByFile: {
        requestsMetadata: GetVerificationsByFileRequestBuilderRequestsMetadata,
    },
    retry: {
        requestsMetadata: RetryRequestBuilderRequestsMetadata,
    },
    retryByFile: {
        requestsMetadata: RetryByFileRequestBuilderRequestsMetadata,
    },
    sendMessage: {
        requestsMetadata: SendMessageRequestBuilderRequestsMetadata,
    },
    sendMessageByFile: {
        requestsMetadata: SendMessageByFileRequestBuilderRequestsMetadata,
    },
    updateStatus: {
        requestsMetadata: UpdateStatusRequestBuilderRequestsMetadata,
    },
    updateStatusByFile: {
        requestsMetadata: UpdateStatusByFileRequestBuilderRequestsMetadata,
    },
    verify: {
        requestsMetadata: VerifyRequestBuilderRequestsMetadata,
    },
    verifyByFile: {
        requestsMetadata: VerifyByFileRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
